<template>
    <kgr-button
        type="grey"
        class="kgr-hidden-print"
        :class="{ left, right }"
        @click="print()"
    >
        {{ $t('print') }}
    </kgr-button>
</template>

<script>
import KgrButton from './KgrButton.vue';

export default {
    components: {
        'kgr-button': KgrButton,
    },
    props: {
        left: {
            type: Boolean,
            required: false,
            default: false,
        },
        right: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    methods: {
        print() {
            window.print();
        },
    },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.left {
    float: left;
}
.right {
    float: right;
}
</style>
